import * as actionTypes from "./actionTypes";

export const investSkillPoint = (generalId: number, skillId: number) => ({
  type: actionTypes.INVEST_SKILL_POINT,
  generalId,
  skillId
});

export const investStrengthBonus = (generalId: number, bonusId: number, tier: number) => ({
  type: actionTypes.INVEST_STRENGTH_BONUS,
  generalId,
  bonusId,
  tier
});

export const investTechPointXP = (generalId: number) => ({
  type: actionTypes.INVEST_TECH_POINT_XP,
  generalId
});
